export default __webpack_public_path__ + "static/media/img2.ddb0e15d.svg";